import { useModelStore } from "src/store";
import { DashboardPage } from "./DashboardPage";


function Dashboards() {

  const selectedDashboard = useModelStore(state => state.selectedDashboard);

  if (!selectedDashboard) {
    return null;
  }
  return (
      <DashboardPage key={selectedDashboard._key} dashboard={selectedDashboard} />
  );
}

export default Dashboards;